<mat-tab-group mat-align-tabs="center" (selectedTabChange)="tabClick($event)">
    <mat-tab label="About Me"></mat-tab>
    <mat-tab label="Technical Skills"></mat-tab>
    <mat-tab label="Work Experience"></mat-tab>
    <mat-tab label="Contact"></mat-tab>
    <mat-tab label="Coming up..."></mat-tab>
</mat-tab-group>

<router-outlet></router-outlet>